import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { updateTag } from '../../services/TagsService';
import { TagKnown } from '../../Pages/ManageTags/TagsTable';
import { FormInput, FormLabelContainer } from '../../StyledComponents/Form';
import { ModalContent } from './ModalContent';

interface UpdateTagNamePanelProps {
  tag: TagKnown;
  onClose: () => void;
}

export const UpdateTagNamePanel = (props: UpdateTagNamePanelProps) => {
  const { tag, onClose } = props;

  const [tagName, setTagName] = useState<string>(tag.tagName ?? '');

  const {
    mutateAsync: updateTagMutate,
    isPending: loading,
    error,
  } = useMutation({
    mutationFn: () => updateTag({ tagId: tag.tagId ?? '', tagName }),
  });

  const handleClose = () => {
    setTagName('');
    onClose();
  };

  const handleUpdateTag = async () => {
    await updateTagMutate();
    handleClose();
  };

  return (
    <ModalContent
      title="Update Tag Name"
      loading={loading}
      error={error}
      handleClose={handleClose}
      submitDisabled={loading || tagName === tag.tagName}
      handleSubmit={handleUpdateTag}
      buttonLabels={{
        loading: 'Updating Tag...',
        create: 'Update',
      }}
    >
      <FormLabelContainer>
        <FormInput
          placeholder="Enter a tag name"
          maxLength={120}
          value={tagName}
          autoCapitalize="none"
          onChange={(event): void => setTagName(event.target.value)}
        />
      </FormLabelContainer>
    </ModalContent>
  );
};
